/* eslint-disable import/no-cycle */
import React from 'react'

import List from 'components/list'
import { getKeysWithIndex } from 'helpers/translations'

import { RefundInformation, ListWrapper } from './styled'

const InformationComponent = ({ refundKey, infoText, t }) => {
  const info = getKeysWithIndex(refundKey, 7)
    .map(trKey => t(trKey))
    .filter(function(e) {
      return !e.startsWith(refundKey)
    })

  return (
    <RefundInformation>
      {t(infoText)}
      <ListWrapper>
        <List keys={info || []} />
      </ListWrapper>
    </RefundInformation>
  )
}

export default InformationComponent
